import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuNavigator from './MenuNavigator';

const MainLayout = ({ children, user, onLogout, onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Obtener nombre y apellido por separado
  const firstName = (user?.name || user?.username || 'USUARIO').toUpperCase();
  const lastName = (user?.lastname || '').toUpperCase();
  
  const userRole = user?.groupname || 'Empleado'; // Ahora usa el groupname del usuario
  const isHomePage = location.pathname === '/inicio';
  
  const handleHelp = () => {};
  const handleSettings = () => {};
  
  const handleLogout = () => {
    sessionStorage.removeItem('userSession');
    if (onLogout) onLogout();
    navigate('/login');
  };
  
  const handleHome = () => navigate('/inicio');
  const handleBack = () => navigate(-1);
  
  const showBackButton = !isHomePage;
  const showHomeButton = !isHomePage;

  return (
    <div className="w-screen h-screen overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col">
      {/* Header con gradiente y sombra mejorada - Optimizado para 1366x768 */}
      <div className="fixed top-0 left-0 right-0 z-50 gradient-red h-[60px] xl:h-[70px] shadow-lg">
        <div className="flex items-center justify-end px-4 xl:px-6 h-full">
          <MenuNavigator
            firstName={firstName}
            lastName={lastName}
            userRole={userRole}
            userGroupname={user?.groupname} // ← NUEVA: Pasamos el groupname
            onHelp={handleHelp}
            onSettings={handleSettings}
            onLogout={handleLogout}
            onHome={handleHome}
            onBack={handleBack}
            onNavigate={onNavigate}
            showBackButton={showBackButton}
            showHomeButton={showHomeButton}
            isHomePage={isHomePage}
          />
        </div>
      </div>
      
      {/* Contenido principal - ocupa todo el espacio disponible - Optimizado para 1366x768 */}
      <div className="pt-[60px] xl:pt-[70px] flex-1 overflow-auto scrollbar-thin">
        <div className="min-h-full flex flex-col">
          <div className="flex-1">
            {children}
          </div>
          
          {/* Footer mejorado - Optimizado para 1366x768 */}
          <div className="border-t border-gray-200 bg-gradient-to-r from-gray-50 to-white py-2 xl:py-3 mt-4 xl:mt-8">
            <div className="relative flex items-center justify-center w-full px-4 xl:px-6">
              <div className="absolute left-2 flex items-center gap-1 xl:gap-2">
                <span className="text-gray-400 text-[10px] xl:text-xs font-medium">powered by</span>
                <img 
                  src="/logoDatco.png" 
                  alt="Datco Logo" 
                  className="h-4 xl:h-5 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
              <p className="text-gray-400 text-[10px] xl:text-xs flex items-center gap-1 xl:gap-2">
                <span className="material-icons text-[10px] xl:text-xs">copyright</span>
                2026 Honda Motor Co., Ltd. - Todos los derechos reservados
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
